<template>
    <div class="block">
        <van-nav-bar
                title="用户服务协议和隐私政策"
                left-text=""
                left-arrow
                @click-left="back()"
        />
        <div class="contentwarp">
           <div>
               <h3 class="layui-timeline-title">重要须知</h3>
               <p>
                   《用户服务协议和隐私政策》（以下简称“协议”）及其条款，系确立您与无锡云储科技有限公司之间就下载、安装及使用“大宗云仓”软件（以下简称“本软件”或“大宗云仓”）所订立的、描述您与大宗云仓之间权利义务的协议。
                   在注册前务必认真阅读本协议的内容、充分理解各条款内容，如有异议，您可选择不进入大宗云仓。一旦您确认本用户注册协议后，本协议即在您和大宗云仓之间产生法律效力，意味着您完全同意并接受协议的全部条款。请您审慎阅读并选择接受或不接受协议（未成年人应在法定监护人陪同下阅读）。
               </p>

               <h3 class="layui-timeline-title">用户使用</h3>
               <p>
                   1、用户按照页面给与的提示完成全部注册步骤后，即成为大宗云仓的用户，用户应自行保管账号及密码，并准确、安全地使用其账号及密码。大宗云仓可通过用户自行设定，向用户提供个性化信息服务。</p>
               <p>  2、用户充分了解并同意，大宗云仓为用户提供个性化信息服务，用户须为自己注册账号下的行为负责，包括用户所导入、上载、传送的任何内容以及由此产生的任何后果，用户应对大宗云仓中的内容自行加以判断，并承担因使用内容而引起的所有风险。大宗云仓不对因用户行为而导致的损失承担责任。</p>
               <p>  3、用户须对在大宗云仓上所传送信息的真实性、合法性、有效性等负责，与用户所传播的信息相关的任何法律责任由用户自行承担，与大宗云仓无关。用户在大宗云仓中记录的或通过大宗云仓服务所传送的任何内容并不反映大宗云仓的观点或政策，大宗云仓对此不承担责任。</p>
               <p>  4、用户提供的个人信息或发布的信息不真实、不准确、不合法；发表内容不符合本协议或发表内容不符合法律法规的，大宗云仓有权暂停或终止用户使用本平台的服务。用户如果对大宗云仓的暂停或者终止或收回其账号行为有异议，客户可向平台提出意见，要求其继续提供服务。大宗云仓收到客户此类信息的投诉与意见，会审核相关信息，并及时对用户给予反馈。若信息确实不真实或不准确或不合法有效，大宗云仓平台要求用户提供符合要求的信息。</p>
               <p>  5、为避免用户终端数据丢失、更好服务用户之目的，大宗云仓将向注册用户提供数据备份服务，经注册用户授权，大宗云仓将存储于注册用户终端的大宗云仓数据库中的数据资料上载至大宗云仓服务器，并且提供恢复到终端设备服务。</p>
               <p>  6、用户不得利用大宗云仓服务制作、上载、复制、发布、传播或者转载如下内容：<br/>
               6.1、反对宪法所确定的基本原则的；<br/>
               6.2、危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br/>
               6.3、损害国家荣誉和利益的；<br/>
               6.4、煽动民族仇恨、民族歧视，破坏民族团结的；<br/>
               6.5、破坏国家宗教政策，宣扬邪教和封建迷信的；<br/>
               6.6、散布谣言，扰乱社会秩序，破坏社会稳定的；<br/>
               6.7、散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br/>
               6.8、侮辱或者诽谤他人，侵害他人合法权益的；<br/>
               6.9、法律、行政法规禁止的其他内容。</p>
               <p class="sj">大宗云仓有权针对用户发表的内容进行审核，若用户实施违反本条所述使用规则及法律法规的行为，大宗云仓平台有权视行为严重程度，根据《侵权责任法》《信息网络传播权保护条例》等法律法规要求用户立即采取纠正、改正、恢复原状、消除影响等行为，且大宗云仓有权自行采取合法有效且必要的措施（包括但不限于更改或删除相关侵权信息、暂停或终止用户使用本网络服务等），同时大宗云仓保留进一步追究用户法律责任的权利。
                   同时，大宗云仓平台的管理者应当履行与本协议权利、法律法规相适应的义务，对违反法律规定和协议约定、履行责任义务不到位的服务提供者应当依法依约限制（更改或删除相关侵权信息、暂停使用）或取消其管理权限，直至封禁或者关闭有关账号。
               </p>


               <h3 class="layui-timeline-title">隐私政策</h3>
               <p> 大宗云仓尊重并保护所有使用服务用户的个人隐私权，高度重视用户的隐私及个人信息的保护，本隐私政策帮助您了解我们收集哪些数据、为什么收集这些数据，会利用这些数据做些什么及如何保护这些数据。
                   我们将依据《中华人民共和国网络安全法》、《信息安全技术个人信息安全规范》以及其他相关法律法规、业界成熟的安全标准收集和本协议的约定使用您的个人信息，除本隐私权政策另有规定外，在未征得您事先许可的情况下，大宗云仓不会将这些信息对外披露或向第三方提供。</p>
               <p>  1、收集和使用个人信息的范围。</p>
               <p>  1.1、注册账号：您注册并登录大宗云仓货主平台账号时至少向我们提供企业名称、统一社会信用代码、企业联系电话号码、所在城市及详细地址、营业执照、管理员姓名、身份证号码、身份证正反面照片和授权文件，并创建密码；您注册并登录大宗云仓提货人服务平台账号时至少向我们提供姓名、身份证号码和手机号码。注册成功后，您提供的上述信息，将在您使用大宗云仓平台和服务期间持续授权我们使用。在您注销账号时，我们将停止使用并删除上述信息或对您的个人信息进行匿名化处理，法律法规另有规定的除外。</p>
               <p>1.2、同时使用手机号码注册成功后，我们可能收集如下信息：<br/>
                   1.2.1、设备信息：以便我们能在设备上为您提供服务，我们可能会将您的设备信息或电话号码与账号相关联，并收集设备属性信息、设备状态信息、设备链接信息。<br/>
                   1.2.2、身份认证服务：大宗云仓提供身份认证服务，当您申请成为大宗云仓用户为您进行身份认证时我们需要收集您的出生日期、时间、出生地点有关身份证明的信息。<br/>
                   1.2.3、信息发布功能：您注册成功后，可在大宗云仓平台发布信息，对信息的内容，我们将不时进行审核，并根据法律规定对该内容进行保存。</p>
               <p> 1.3、其他用途：当我们要将信息用于本隐私政策未载明的其他用途，将会事先征求您的同意。<br/>
                   按照法律法规要求，下列如下情况我们将无法满足您的上述请求：<br/>
                   1.3.1、与国家安全、国家利益相关的；<br/>
                   1.3.2、与公共安全、公共利益相关的；<br/>
                   1.3.3、与您或者第三方重大利益相关并可能会导致严重损害的；<br/>
                   1.3.4、与犯罪、司法程序、政府程序等直接相关的；<br/>
                   1.3.5、您存在主观恶意或滥用权利的（如您的请求将危害公共安全和其他人合法权益，或您的请求超出了一般技术手段和商业成本可覆盖的范围）；<br/>
                   1.3.6、涉及商业秘密的;</p>
               <p> 2、我们如何保护您的个人信息<br/>
                   为防止您的信息丢失、未经您同意授权的访问、公开披露、泄露、转让等导致您个人信息的受损，大宗云仓平台将采取一切合理、可靠、可行的方案与措施，保障您的个人信息安全。</p>
               <p> 2.1、安全措施：<br/>
                   2.1.1、我们将以国家安全标准和法律法规的规定收集、使用、存储和传输用户信息，并通过用户协议和隐私政策告知您相关信息的使用目的和范围。同时，我们会对个人信息进行加密技术，以确保数据的保密性与安全性。<br/>
                   2.1.2、对员工信息接触者签署保密协议，定期进行安全能力与意识的培训。专岗专职，只有授权员工方可访问个人信息，若违反保密协议，将追究员工相关法律责任。<br/>
                   2.1.3、严格选择合作伙伴，对其进行背景调查，与有知名度且信誉良好的企业合作；与合作伙伴信息接触者签署保密协议，约定泄密的违约责任，并仅提供必要合理的信息。<br/>
                   2.1.4、成立安全团队，安全团队负责研发和应用安全技术和程序，以确保大宗云仓平台及个人信息的安全。我们将对安全团队负责人和信息技术负责人进行背景调查，签署保密协议，约定泄密的法律责任，并持续对其进行安全能力与意识的培训。<br/>
                   2.1.5、我们建立完善的信息安全管理制度和内部安全事件处置机制等。</p>
               <p>2.2、保存期限<br/>
                   您在使用大宗云仓产品及服务期间，我们将持续为您保存您的企业或个人信息。如果您将企业或个人信息修改，我们会保存修改后的信息。
                   如果您注销帐户后，我们不会再对您的企业或个人信息进行使用，我们将依据网络安全法等法律法规规定保存您企业的信息并进行匿名化处理。</p>
               <p> 2.3、安全事件通知<br/>
                   2.3.1、我们会预先制定互联网安全事件预警方案，及时处置系统漏洞、计算机病毒、网络攻击、网络侵入等安全风险，在发生危害网络安全的事件时，我们会立即启动应急预案，采取相应的补救措施，并按照规定向有关主管部门报告。<br/>
                   2.3.2、若发生企业和个人信息安全事件，我们将通过您预留的企业和个人信息（包含手机号码、电子邮箱等）及时通知您，并告知您案件进展和影响，我们将联合安全团队、法务部、技术部共同采取积极有效的处理手段，采取补救措施以降低风险。同时，我们将根据有关政府部门及法律法规要求，主动上报安全事件的情况，并可能采取法律手段解决安全事件。<br/>
                   2.4、如果决定更改隐私政策，我们会在本政策中及我们认为适当的位置发布这些更改，以便您了解我们如何收集、使用您的个人信息，哪些人可以访问这些信息，以及在什么情况下我们会透露这些信息。</p>
               <p> 3、您管理企业或个人信息的权利<br/>
                   我们非常重视您对企业和个人信息的关注，并尽全力保护您对于企业和自己个人信息访问、更正、删除以及撤回同意的权利，以使您拥有充分的能力保障您的隐私和安全。 您的权利包括：</p>
               <p> 3.1、访问和更正您的企业或个人信息<br/>
                   除法律法规规定外，您有权随时访问和更正您的企业或个人信息，具体包括：您可通过货主平台【帐户信息】访问或者修改用户名、手机号、密码和企业信息；您可通过提货人服务平台【我的】 ，访问或者修改您的手机号；</p>
               <p> 3.2、删除您的企业或个人信息<br/>
                   在以下情形中，您可以向我们提出删除企业或个人信息的请求：<br/>
                   如果我们处理企业或个人信息的行为违反法律法规；<br/>
                   如果我们收集、使用您的企业和个人信息，却未征得您的同意；<br/>
                   如果我们处理企业和个人信息的行为违反了与您的约定；<br/>
                   如果我们终止服务及运营。<br/>
                   当您从我们的服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息。</p>


               <h3 class="layui-timeline-title">法律责任与免责</h3>
               <p>
                   1、大宗云仓平台对平台进行停机维护、定期检查、更新软硬件、针对突发事件、不可抗力、电脑病毒、系统故障等因素导致的正常服务中断、中止，大宗云仓不承担责任，大宗云仓平台将尽力避免服务中断并将中断时间限制在最短时间内。</p>
               <p> 2、用户因第三方如电信部门的通讯线路故障、技术问题、网络、电脑故障、系统不稳定性及其他各种不可抗力原因而遭受的一切损失，大宗云仓不承担责任。</p>
               <p> 3、因用户违反本协议或相关的服务条款的规定，导致或产生的任何第三方向大宗云仓主张的索赔，由用户自行承担。</p>
               <p>  4、用户在大宗云仓平台发表的观点及立场，并不代表大宗云仓的立场，用户应自行对发表内容负责。</p>
               <p>  5、请客户自行妥善保管企业和个人资料，将企业和个人信息提供足够保障及备份，并采取适当的预防措施降低电脑病毒或其他恶意破坏性举动的风险。</p>
               <p>  6、由于您的隐私权对本网站相当重要，除非有权机关依法调取或者第三条约定，大宗云仓平台不会无故把您的企业和个人信息提供给无关的第三方，但不对第三人恶意侵权导致信息泄露而产生的后果负责。
               </p>

               <h3 class="layui-timeline-title">知识产权</h3>
               <p>1、本软件是由大宗云仓开发。大宗云仓的一切知识产权，以及与软件相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图像、图表、色彩、界面设计、版面框架、有关数据、附加程序、印刷材料或电子文档等均归大宗云仓所有，受著作权法和国际著作权条约以及其他知识产权法律法规的保护。</p>
               <p>2、未经大宗云仓书面同意，用户不得为任何营利性或非营利性的目的自行实施、利用、转让或许可任何三方实施、利用、转让上述知识产权。出现上述未经许可之行为时，大宗云仓保留追究相关责任人法律责任之权利。</p>

               <h3 class="layui-timeline-title">修改与解释权</h3>
               <p>根据互联网的发展和有关法律、法规及规范性文件的变化，或者因业务发展需要，大宗云仓有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，您可在大宗云仓官方网站查阅最新版协议条款，该公布行为视为大宗云仓已经通知用户修改内容，而不另行对用户进行个别通知。在大宗云仓修改协议条款后，如果您不接受修改后的条款，请立即停止使用大宗云仓提供的服务，您继续使用大宗云仓提供的服务将被视为已接受了修改后的协议。</p>

               <h3 class="layui-timeline-title">通知</h3>
               <p>您在注册成为大宗云仓用户，并接受大宗云仓服务时，您应该大宗云仓提供真实有效的联系方式（包括您的电子邮件地址、联系电话、联系地址等），对于联系方式发生变更的，您有义务及时更新有关信息，并保持可被联系的状态。
                   大宗云仓将向您的上述联系方式的其中之一或其中若干向您送达各类通知。平台信息发送成功后即视为送达；以纸质载体发出的书面通知，按照提供联系地址交邮后的第五个自然日即视为送达。</p>

               <h3 class="layui-timeline-title">法律适用、管辖与其他</h3>
               <p>1、大宗云仓郑重提醒用户注意本协议中可能存在的免除大宗云仓责任和加重用户义务的条款，请用户仔细阅读，自主考虑风险。<br/>
                   2、本协议之订立、生效、解释、修订、补充、终止、执行与争议解决均适用中华人民共和国法律；如法律无相关规定的，参照商业惯例或行业惯例。<br/>
                   3、与本协议、使用大宗云仓发生的任何争议或纠纷，双方应尽量友好协商解决；协商不成时，任何一方均有权将纠纷交由北京市海淀区人民法院管辖。<br/>
                   4、本协议任一条款被视为废止、无效或不可执行，该条应视为可分的且并不影响本协议其余条款的有效性及可执行性。</p>
           </div>
        </div>
        <div class="footer">
            <van-button  type="info"  style="font-size: 16px;width:100%" @click="closebtn()">
                关闭
            </van-button>
           <!-- <van-button @click="closebtn()">关闭</van-button>-->
        </div>
    </div>
</template>

<script>

    import { NavBar,Button} from 'vant';

    export default {
        name: "Agreement",
        components: {
            [NavBar.name]: NavBar,
            [Button.name]: Button
        },
        data() {
            return {
                activeNames: ['1',"2"],
            };
        },
        methods: {
            back(){
                this.$router.replace("/RegisterDelivery")
            },
            closebtn(){
                this.$router.replace("/RegisterDelivery")
            }
        }
    }
</script>

<style scoped>
    .block{
        width: 100%;
        height:100vh
    }
    .contentwarp{
        font-size: 12px;
        text-align: left;
        width: 90%;
        margin:0px auto;
        overflow-y: scroll;
        height: calc(100vh - 100px);
        background: #f7f8fa;
        color: dimgray;
        padding: 0 10px;
    }
    .footer{
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0px;
        /*margin: 0 16px;*/
    }
    /deep/ .van-nav-bar .van-icon{
        color: #6685a4;
    }

    /deep/ .van-button--info ,
    /deep/ .van-button--danger{
        /*background-color: #6685a4 ;*/
        /*border: 1px solid #6685a4 ;*/
        background-color: white;
        border: 1px solid white;
        color:#6685a4;

    }
</style>